import React, { useState } from "react";
import { FileText, Download, X } from "lucide-react";
import { adminServices } from "../services/AdminServices";
import { toast } from "react-toastify";

const normalizePoList = (poList) => {
  if (!Array.isArray(poList) || poList.length === 0) return [];
  return poList.map((p) => {
    const filename = p.filename || p.FileName || "PO.pdf";
    return {
      id: p.purchase_order_id ?? p.purchaseOrderId ?? p.id,
      purchase_order_id: p.purchase_order_id ?? p.purchaseOrderId ?? p.id,
      filename,
      label: filename.length > 14 ? filename.slice(0, 14) + "..." : filename,
    };
  });
};

const CreateDeliveryNoteModal = ({ isOpen, onClose, onProceed, poList = [] }) => {
  const [selectedPORef, setSelectedPORef] = useState(null);

  if (!isOpen) return null;

  const modalPoList = normalizePoList(poList);

  const handleClose = () => {
    setSelectedPORef(null);
    onClose?.();
  };

  const handleProceed = () => {
    if (!selectedPORef) return;
    onProceed?.(selectedPORef);
    setSelectedPORef(null);
  };

  const handleDownload = async (e, item) => {
    e.stopPropagation();
    if (String(item.purchase_order_id).startsWith("dummy")) return;
    try {
      await adminServices.downloadPOPdf(item.purchase_order_id, item.filename);
    } catch {
      toast.error("Failed to download PO");
    }
  };

  return (
    <div
      className="dn-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
    >
      <div className="dn-modal-box">
        {/* Header */}
        <div className="dn-modal-header">
          <h2 className="dn-modal-title">Create Delivery Note</h2>
          <button className="dn-modal-close" onClick={handleClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>

        {/* Subtitle */}
        <p className="dn-modal-subtitle">Choose Purchase Order Reference</p>

        {/* PO List */}
        <div className="dn-modal-po-list">
          {modalPoList.length === 0 && (
            <div style={{ padding: 16, color: "#6b7280", textAlign: "center" }}>
              No Purchase Orders available
            </div>
          )}
          {modalPoList.map((item) => (
            <div
              key={item.id}
              className={`dn-modal-po-row${selectedPORef?.id === item.id ? " dn-modal-po-row--selected" : ""}`}
              onClick={() => setSelectedPORef(item)}
            >
              <FileText size={16} className="dn-modal-po-icon" />
              <span className="dn-modal-po-label">{item.label}</span>
              <span className="dn-modal-po-filename">{item.filename}</span>
              <button
                className="dn-modal-po-download"
                onClick={(e) => handleDownload(e, item)}
                title="Download"
                aria-label="Download PO"
              >
                <Download size={16} />
              </button>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="dn-modal-footer">
          <button className="dn-modal-btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="dn-modal-btn-proceed"
            disabled={!selectedPORef}
            onClick={handleProceed}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateDeliveryNoteModal;
